import { getAppData } from '../../../lib/api/common';
import { 
	getPodcastsPage, 
	getPodcastsPageBySite,
	getPodcastsBySite,
	getPodcastsFromAPI
} from '../../../lib/api/podcasts';
import {
	getCompanies,
	getCompanySiteData,
	getCompanySubPages,
	getCompanySubPageByUri
} from '../../../lib/api/company';

import Layout from '../../../components/layout/Layout';
import SeoMaticHead from '../../../components/common/SeoMaticHead'
import PageHeader from '../../../components/content/page/PageHeader';
import PodcastsList from '../../../components/content/PodcastsList';
import { revalidateSeconds } from "../../../lib/helpers/revalidateSeconds";

export type PodcastsProps = {
	page: any
	app: any
	podcasts: any
	podcastIndex: any
}

export async function getStaticPaths() {
	// Get all companies and use as base segment
	const companies: any = await getCompanies();


	const paths = []
	for ( let company of companies.entries ) {

		const pages: any = await getCompanySubPages( company.uri )
		if ( pages?.entries ) {

			for ( let page of pages.entries ) {

				const uri = page.uri.split('/')
				const splitUri = uri.shift() // Removing first item ( siteHandle ) from array

				paths.push({
					params: {
						siteHandle: company.slug,
						uri: uri
					}
				})
			}
		}
	}

	return {
		paths,
		fallback: 'blocking',
	}
}

export async function getStaticProps(context: any) {
	const siteHandle: string = context?.params?.siteHandle


	// Add sitehandle to the front of uri array
	const app: any = await getAppData();
	const data: any = await getPodcastsPageBySite(
		siteHandle,
		context.preview ? context.previewData?.token : undefined
	);
	let podcasts: any = null;
	let podcastsFromAPI: any = null;

	if (siteHandle == 'securities') {
		podcastsFromAPI = await getPodcastsFromAPI();
		podcastsFromAPI.sort((a:any, b:any) => {
			return new Date(b.published_at).valueOf() - new Date(a.published_at).valueOf();
		});
	} else {
		podcasts = await getPodcastsBySite(siteHandle);
	}

	return {
		props: {
			app: app ? app : null,
			page: data ? data.page : null,
			podcastIndex: data ? data.podcastIndex : null, 
			podcasts: podcastsFromAPI ? podcastsFromAPI : podcasts ? podcasts.entries : null
		},
		revalidate: revalidateSeconds()
	};
}



export default function Podcasts(props: PodcastsProps) {

	const { app, page, podcasts, podcastIndex } = props
	const breadcrumbs = [
		{
			id: podcastIndex?.id,
			title: podcastIndex?.title,
			uri: podcastIndex?.uri,
		},
		{
			id: page?.pageHeader?.[0]?.id,
			title: page?.pageHeader?.[0]?.heading,
			uri: null
		}
	]
	return (
		<>
			<SeoMaticHead seo={page?.seo} />
			<Layout
				appData={app}
				subHeader={breadcrumbs}
			>
				<>
					{page && <PageHeader page={page} />}
					<PodcastsList
						heading={'Podcasts'}
						addArchiveLink={false}
						podcasts={podcasts}
					/>
				</>
			</Layout>
		</>
	)
}
